// app/src/components/mobile/HeaderMobilePro.tsx
import React, { FC } from 'react';
import { useTranslation } from "react-i18next";
import { useUrlContext } from '../../../contexts/UrlContext';
import LanguageSelectorMobile from "../atomicDesignMobile/atoms/LanguageSelectorMobile";


const HeaderMobilePro: FC = () => {
	const { t } = useTranslation();
	const { redirectToHomePro, goBackWithFallback } = useUrlContext();

	return (
		<header
			style={{
				width: 390,
				height: 39,
				padding: '15px 0',
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				alignItems: 'center',
			}}
		>
			<div
				style={{
					width: 48,
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'left',
					alignItems: 'center',
					gap: 5,
					cursor: 'pointer',
					marginLeft: 12,
				}}
			>
				<img
					src="/images/chevron-left.svg"
					alt="left-chevron"
					style={{ width: 20 }}
				/>
				<div
					style={{ fontSize: 11 }}
					onClick={goBackWithFallback}
				>
					{t('header:back')}
				</div>
			</div>

			<img
				src="/images/logo-VPauto-pro.svg"
				alt="VPAuto logo"
				style={{ width: 108 ,cursor: 'pointer',}}
				onClick={redirectToHomePro}
			/>
			
			<LanguageSelectorMobile/>
		</header>
	);
};

export default HeaderMobilePro;
